// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__30zzF","disabled":"Button_disabled__34bzI"};